/**
 * 呼び出し元画面に返却する情報を格納するVO
 */
export class KYMW0700OutputModel {
  /** 商品文字情報種別 */
  public textKindId: string = <string>'';
  /** 文字列 */
  public stringValue: string = <string>'';
  /** 連番 */
  public textKindNum: number = <number>-1;
  /** 文字情報件数 */
  public textInfoCnt: string = <string>'0件';
}
